import Route from '@ember/routing/route';

export default class DashboardDynamicViewReportsRoute extends Route {
  renderTemplate() {
    this.render({
      into: 'dashboard',
    });
  }
}
